export default "__VITE_PUBLIC_ASSET__39553fcc__"